import React from "react";
import styles from "./FAQ.module.scss";
import { useState } from "react";
const FAQ = ({ faqRef }) => {
  const [firstClick, setFirstClick] = useState(false);
  const [secondClick, setSecondClick] = useState(false);
  const [thirdClick, setThirdClick] = useState(false);
  const [fourthClick, setFourthClick] = useState(false);
  const [fifthClick, setFifthClick] = useState(false);
  const [sixthClick, setSixthClick] = useState(false);

  const onClick = (id) => {
    switch (id) {
      case 1:
        setFirstClick(!firstClick);

        return;
      case 2:
        setSecondClick(!secondClick);

        return;
      case 3:
        setThirdClick(!thirdClick);

        return;
      case 4:
        setFourthClick(!fourthClick);

        return;
      case 5:
        setFifthClick(!fifthClick);

        return;
      case 6:
        setSixthClick(!sixthClick);
        return;
      default:
        setFirstClick(false);
        setSecondClick(false);
        setThirdClick(false);
        setFourthClick(false);
        setFifthClick(false);
        setSixthClick(false);
        return;
    }
  };
  return (
    <div className={styles.container} ref={faqRef}>
      <h1 data-content="FAQ">FAQ</h1>
      <ul className={styles.faqList}>
        <li>
          <span onClick={() => onClick(1)}>
            <span className={styles.icon_box}></span>

            <div>
              <h1 data-content="How can I get in contact with publishing managers?">
                How can I get in contact with publishing managers?
              </h1>

              {firstClick && (
                <p>
                  For the fastest response, you can contact us through{" "}
                  <a
                    className={styles.discord}
                    href="https://discord.gg/Cf6smsvk7a"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Discord
                  </a>
                  . You can also send us an email at{" "}
                  <a
                    className={styles.mail}
                    href="mailto:publishing@mondayoff.me"
                    target="_blank"
                    rel="noreferrer"
                  >
                    publishing@mondayoff.me
                  </a>
                </p>
              )}
            </div>
          </span>
        </li>
        <li>
          <span onClick={() => onClick(2)}>
            <span className={styles.icon_box}></span>
            <div>
              <h1 data-content="How can I submit my game to the competition?">
                How can I submit my game to the competition?
              </h1>
              {secondClick && (
                <p>
                  Go onto our{" "}
                  <a
                    href="https://dashboard.mondayoff.me"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.dashboard}
                  >
                    Dashboard
                  </a>{" "}
                  and follow all stated steps to submit.
                </p>
              )}
            </div>
          </span>
        </li>
        <li>
          <span onClick={() => onClick(3)}>
            <span className={styles.icon_box}></span>
            <div>
              <h1 data-content="Can I submit multiple game submissions?">
                Can I submit multiple game submissions?
              </h1>
              {thirdClick && (
                <p>
                  You can submit multiple submissions, but please make sure each
                  submission is a different game. Also, please remember not to
                  submit too many games simultaneously, as the system may flag
                  them as spam.
                </p>
              )}
            </div>
          </span>
        </li>
        <li>
          <span onClick={() => onClick(4)}>
            <span className={styles.icon_box}></span>
            <div>
              <h1 data-content="Is this competition for Hybrid-Casual games only?">
                Is this competition for Hybrid-Casual games only?
              </h1>
              {fourthClick && (
                <p>
                  You can submit any genre of game you wish to as long as it is
                  in the hyper-casual, idle arcade, and hybrid casual genre.
                </p>
              )}
            </div>
          </span>
        </li>
        <li>
          <span onClick={() => onClick(5)}>
            <span className={styles.icon_box}></span>
            <div>
              <h1 data-content="Is the test on Android only?">
                Is the test on Android only?
              </h1>
              {fifthClick && (
                <p>
                  Yes, we test Android games developed on Unity. Please ensure
                  your game is live on the Google Play Store with the MondayOFF
                  SDK before submitting it for testing.
                </p>
              )}
            </div>
          </span>
        </li>
        <li>
          <span onClick={() => onClick(6)}>
            <span className={styles.icon_box}></span>
            <div>
              <h1 data-content="Do the competition iterations have a deadline?">
                Do the competition iterations have a deadline?
              </h1>
              {sixthClick && (
                <p>
                  Yes, please make sure that you submit the last iteration of
                  your game before the competition ends. If not, that iteration
                  won’t be counted as a competition iteration.
                </p>
              )}
            </div>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default FAQ;
